export default "__VITE_ASSET__BzdQRE72__"